import React, { useMemo, useState } from 'react'
import { EditCartItemProps, SipValidationType, StpValidationType } from '../types'
import { Box, Checkbox, Grid, Skeleton, Typography, useTheme } from '@mui/material'
import { Formik, FormikValues, useFormik } from 'formik';
import { StpScheme, SwitchScheme } from './Scheme';
import { CheckIcon, UnCheckIcon } from '../../../assets/SvgIcons';
import { MandateCreation } from '../../../redux-store/types/investorProfile';
import { InvestmentFundType } from '../../../redux-store/types/api-types';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { CustomeBlueDropDown, CustomeModalButton, CustomeNumberInput, FormCheckBox } from '../../investorOverview/transcation/FromInput';

type Props = {
    data: EditCartItemProps
    currentTransactionType: string
    validation: StpValidationType
    scheme: InvestmentFundType
    bankDetails: MandateCreation[]
    schemeLoading: boolean
}

export default function Switch(props: Props) {
    const { data, currentTransactionType, validation, scheme, bankDetails, schemeLoading } = props
    const { onSave, switchValue, frequency, onCancel, noOfInstallments, marketValue, isLoading, transMode, balanceAmount, balanceUnits, bankAccountNumber, freeUnits, nav } = data
    const { locale, currencyCode, currencySymbol } = useSelector((store: RootStateType) => store.currencyInfo);
    const entireBalanceCheck = data?.allUnitsFlag;

    const entireAmountValue = Math.round((!Number.isNaN(Number(nav ?? 0)) ? Number(nav ?? 0) : 0) * (freeUnits ?? 0))

    const { palette, typography } = useTheme()

    // sheme
    const schemeValidation = SwitchScheme({ validation, switchValue, switchType: transMode, accountType: '', scheme, freeUnits: freeUnits ?? 0 })

    const filterValidation = scheme?.validations?.filter((item) => item?.transactionType === 'RED')?.[0]



    // handleSubmit
    function handleSubmitBtn(formValues: FormikValues) {
        onSave(
            data.id,
            currentTransactionType,
            {
                amount: formValues.switchType === "A" ? formValues.switchValue : "",
                units: formValues.switchType === "U" ? formValues.switchValue?.toString() : "",
                transMode: formValues.switchType,
                allUnitsFlag: formValues.entireBalance ? 'Y' : 'N'
            }
        )
    }

    return (
        <Formik
            initialValues={{
                switchType: transMode,
                switchValue: switchValue,
                // accountType: bankAccountNumber,
                entireBalance: (entireAmountValue == switchValue) || (entireBalanceCheck === "Y" ? true : false)
                // entireBalance: entireBalanceCheck === "Y" ? true : false
            }}
            onSubmit={handleSubmitBtn}
            validationSchema={schemeValidation}
            enableReinitialize
        >
            {(formik) => <Box component={'form'} onSubmit={formik.handleSubmit}>
                <Grid container>
                    <Grid item xs={4} sm={5} md={6} lg={6}>
                        <CustomeBlueDropDown
                            isLoading={schemeLoading}
                            disabled={isLoading || formik.values.entireBalance}
                            name={'switchType'}
                            label={'Switch Value'}
                            list={[{ value: 'A', label: 'Amount' }, { value: 'U', label: 'Units' }]}
                            boxStyle={{
                                borderTopRightRadius: '0px',
                                borderBottomRightRadius: '0px',
                                borderRight: `1px solid ${palette.text.secondary}b2`
                            }}
                            onChange={async (event, value) => {
                                await formik.setFieldValue('switchType', event.target.value);
                                await formik.validateField("switchValue")
                                await formik.setFieldValue('switchValue', '')
                                if (event.target.value === 'A') {
                                    await formik.setFieldValue('entireBalance', false)
                                }
                            }} />

                        <FormCheckBox name='entireBalance'
                            isLoading={schemeLoading}
                            disabled={isLoading}
                            onChange={async (event, value) => {
                                formik.setFieldValue('entireBalance', value);
                                if (value) {
                                    await formik.setFieldValue('switchType', 'U');
                                    await formik.setFieldValue('switchValue', `${freeUnits}`)
                                    // await formik.setFieldValue('switchValue', formik.values.switchType === "A" ? `${entireAmountValue}` : `${freeUnits}`)
                                }
                            }}
                        />

                        {/* {formik.values.switchType === "U" &&
                            <FormCheckBox name='entireBalance'
                                isLoading={schemeLoading}
                                disabled={isLoading}
                                onChange={(event, value) => {
                                    formik.setFieldValue('entireBalance', value);
                                    if (value) {
                                        formik.setFieldValue('switchValue', formik.values.switchType === "A" ? `${entireAmountValue}` : `${freeUnits}`)
                                    }
                                }} />
                        } */}
                    </Grid>
                    <Grid item xs={8} sm={7} md={6} lg={6}>
                        <CustomeNumberInput
                            // minValue={12}
                            name={'switchValue'}
                            defaultValue={switchValue}
                            isLoading={schemeLoading}
                            disable={formik.values.entireBalance || isLoading}
                            removeIcons={formik.values.switchType === "U"}
                            minlabel={`${`${formik.values?.switchType || transMode}` === "A" ? `Min: ${(String.fromCharCode(parseInt(currencySymbol, 16)) + " " + (filterValidation?.minimumInstallmentAmount || 0))}` : `Max: ${freeUnits || 0}`}`}

                            textType='number'
                            boxStyle={{
                                borderTopLeftRadius: '0px',
                                borderBottomLeftRadius: '0px',
                                marginTop: '3px',
                            }}
                            warningText={formik.values?.switchType === 'A' ? 'amount' : 'units'} />
                    </Grid>
                    {/* <Grid item lg={6} md={6} sm={12} xs={12} sx={{ paddingBottom: "20px" }}>
                <CustomeBlueDropDown
                    name={'accountType'}
                    isLoading={schemeLoading}
                    error={touched.accountType ? (errors.accountType || '') : ''}
                    label='Select Account'
                    defaultValue={bankAccountNumber}
                    handleOnChange={handleOnChange}
                    list={[...bankDetails]?.map((item: MandateCreation) => ({ value: item?.bankAccountNumber, label: item?.bankName }))}
                />
            </Grid> */}
                    <Grid
                        item
                        container
                        xs={12}
                        mt={2}
                        spacing={2}
                        sx={{
                            justifyContent: "center",
                            alignItems: "center",
                            borderTop: `0.5px solid ${palette.text.secondary}B2`
                        }}
                    >
                        <Grid
                            item
                            xs={12}
                            md={6}
                            mt={2}
                        >
                            <CustomeModalButton
                                // isLoading={isLoading || schemeLoading}
                                type='button'
                                disabled={isLoading || schemeLoading}
                                onClick={() => onCancel()}
                                variant='outlined'
                                btnText='Cancel'
                                boxStyle={{
                                    color: palette.text.primary,
                                }}
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={6}
                            mt={2}
                        >
                            <CustomeModalButton
                                type='submit'
                                isLoading={isLoading}
                                disabled={!formik.dirty || schemeLoading}
                                variant='contained'
                                btnText='Save Changes'
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Box>}
        </Formik>
    )
}